import PropTypes from 'prop-types';
import ModalWrapper from 'common/components/modules/modal-wrapper';
import classNames from 'classnames';

const AgeVerificationModalWrapper = ({
   children,
   isMobile,
   onCloseModal,
   icon,
   title,
   description,
   imageAsIconSrc,
   withoutCloseButton = false,
}) => {

   return (
      <ModalWrapper
         type='confirm'
         contentWidth='960px'
         isMobile={ isMobile }
         isPreventDeafault={ false }
         withoutCloseButton={ withoutCloseButton }
         closeBtnClassName='shrink-0'
         onCloseModal={ onCloseModal }
         icon={ icon }
         // modalWrapperClassName='!h-full !min-h-[90%] flex flex-col'
         modalWrapperClassName={ classNames({
            '!h-full flex flex-col': true,
            '!max-h-[720px]': !isMobile,
            '!min-h-[90%]': isMobile,
         }) }
         // className='h-full'
         className='flex-1'
         title={ title }
         description={ description }
         withoutConfirmButton
         withoutCancelButton
         imageAsIconSrc={ imageAsIconSrc }
         imageAsIconClassName='!object-fill'
         titleLeading='leading-6'
      >
         {children}
      </ModalWrapper>
   )
}

AgeVerificationModalWrapper.propTypes = {
   children: PropTypes.any,
   isMobile: PropTypes.bool,
   onCloseModal: PropTypes.func,
   icon: PropTypes.string,
   title: PropTypes.string,
   description: PropTypes.string,
   imageAsIconSrc: PropTypes.string,
   withoutCloseButton: PropTypes.bool,
}

export default AgeVerificationModalWrapper;
